<template>
  <div>
    <div v-if="showNotesComponent" class="new-session-div">
      <div>
        <BackButtonIcon @click="showTBNewSessionFunction()" class="hover-effect" />
        <span class="label-span">Notes</span>
      </div>
      <div>
        <Textarea v-model="notesValue" rows="9" cols="27" placeholder="Add Notes..." />
      </div>
    </div>
    <div v-else>
      <div class="new-session-div">
        <div>
          <span class="label-span">Tumor Board</span>
        </div>
        <div>
          <Dropdown v-model="selectedTumorBoard" editable :options="tumorBoardsDropdown" optionLabel="tbName"
            placeholder="Select Tumor Board" class="custom-placeholder-color" />
        </div>
        <div>
          <span class="label-span">Primary Diagnosis</span>
        </div>
        <div>
          <Dropdown v-model="selectedDiagnosis" emptyMessage="No cancer diagnosis found" editable
            :options="patientDiagnosisDropdown" optionLabel="diagnosis" placeholder="Select Primary Diagnosis"
            class="custom-placeholder-color" />
        </div>
        <div>
          <span class="label-span">Notes</span>
        </div>
        <div>
          <Button :label="dynamicButtonLabel" outlined @click="showNotesComponentFunction()" size="small"
            class="custom-placeholder-color" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// Copyright (c) 2020-2023 Omics Data Automation, Inc.
// Copyright (c) 2023 datma, inc.
//
// Proprietary and Confidential:
// Unauthorized copying of this file by any medium is strictly prohibited.

import { ref, onMounted, computed } from 'vue'
import { useStore } from 'vuex'
import Dropdown from 'primevue/dropdown'
import Textarea from 'primevue/textarea'
import Button from 'primevue/button'
import { getTumorBoards } from './getTumorBoards'
import { getPatientDiagnosis } from './getPatientDiagnosis'
import BackButtonIcon from '../../icons/BackButtonIcon.vue'

const store = useStore()
const selectedTumorBoard = ref([])
const selectedDiagnosis = ref([])
const notesValue = ref('')
const tumorBoardsDropdown = ref([])
const patientDiagnosisDropdown = ref([])
const showNotesComponent = ref(false)
const dynamicButtonLabel = ref('Add Notes')
const patient = computed(() => store.getters.session.patient)

onMounted(async () => {
  const tumorBoardsData = await getTumorBoards()
  tumorBoardsDropdown.value = tumorBoardsData.tb_types.map(item => ({ tbName: item.tb_name }))
  const patientDiagnosisData = await getPatientDiagnosis([patient.value.id])
  patientDiagnosisDropdown.value = patientDiagnosisData[patient.value.id].map(item => ({ diagnosis: item.description }))
})

const showNotesComponentFunction = () => {
  showNotesComponent.value = true
}

const showTBNewSessionFunction = () => {
  showNotesComponent.value = false
  dynamicButtonLabel.value = notesValue.value || 'Add Notes'
}

</script>

<style>
.p-dropdown {
  height: 35px;
  width: auto;
}

.p-dropdown-label {
  font-size: 12px;
}

.p-dropdown-item {
  font-size: 12px;

}

.p-dropdown-items-wrapper {
  max-width: 235px;
  height: 150px;
  max-height: 150px;
}

.p-dropdown-panel .p-dropdown-items .p-dropdown-item {
  white-space: initial;
}

.label-span {
  color: var(--Grey600);
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.56px;
}

.new-session-div {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
  align-self: stretch;
  gap: 12px;
}

.custom-placeholder-color ::placeholder {
  overflow: hidden;
  color: var(--Primary);
  text-overflow: ellipsis;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0.24px;
  white-space: nowrap;
}

.p-button-label {
  max-width: 235px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0.24px;
}

.p-button.p-button-outlined {
  border: 1px solid var(--Grey400);
}

.hover-effect {
  margin-right: 9px;
  cursor: pointer;
}
</style>
